// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
import { StaticWappsModal } from './static-wapps-modal'

const STATIC_WAPPS_COMPONENT_ID = 'staticWappsModal'

export const showStaticWappsModal = async () => {
  addModal({ id: STATIC_WAPPS_COMPONENT_ID })
}

export default {
  [STATIC_WAPPS_COMPONENT_ID]: {
    Component: StaticWappsModal,
  },
}
